module.exports = __webpack_public_path__ + "static/b-b11a27cbdfdb6586698bb5f4d0bed262.png";